import { ReactElement } from 'react';
import { useFormikContext } from 'formik';
import { Summary } from '@components';
import { iExtensionFormValues, getSummaryScreen } from '@services/ExtensionService';

function ExtensionStep8(): ReactElement {
  const { values }: { values: iExtensionFormValues } = useFormikContext();
  return (
    <div>
      <Summary summaryFields={getSummaryScreen(values)} />
    </div>
  );
}
export default ExtensionStep8;
